import { Title, useTranslate } from 'react-admin';
import { dataProvider } from '@src/dataProvider';
import { FileUpload } from '@components/FileUpload';
import { dataObject } from '@src/object.type';
import { entityResource as ent } from '@src/entityResource';
import { getDayNo } from '@helpers/date.ext';

const headers = [
    'Code',
    'Latitude',
    'Longitude',
    'Title',
    'Description',
    'Phone number',
    'Visit Day',
    'Sales',
];

export const StoreUpload = () => {
    const translate = useTranslate();
    const verifyData = async (data: dataObject[]) => {
        const normalizedData = data
            .filter((row: dataObject) => {
                // Check if at least one field has a value
                return (
                    row.Latitude ||
                    row.Longitude ||
                    row.Title ||
                    row.Description ||
                    row['Phone number']
                );
            })
            .map((row: dataObject) => {
                return {
                    ...row,
                    Latitude: row.Latitude,
                    Longitude: row.Longitude,
                    Title: row.Title,
                    Code: row.Code
                        ? row.Code
                        : String(row.Title)
                              .replace(/\s/g, '')
                              .replace(/"/g, ''),
                    Phone_number: row['Phone number'],
                    Visit_Day: row['Visit Day'],
                    Sales: row.Sales,
                };
            });

        // get distinct sales form normalizedData
        const sales = normalizedData.map((d: dataObject) => d.Sales);
        const distinctSales = [...new Set(sales)];

        const existingSales = await dataProvider.getMany(ent.USER.NAME, {
            ids: distinctSales,
            meta: {
                column: 'name',
                page: 1,
                perPage: distinctSales.length + 1,
            },
        });

        return normalizedData.map((d: dataObject) => {
            const {
                Latitude,
                Longitude,
                Title,
                Code,
                Description,
                Phone_number,
                Visit_Day,
                Sales,
            } = d;
            const userId = existingSales.data.find(
                e =>
                    String(e.userId).toLowerCase() ===
                    String(Sales).toLowerCase()
            )?.id;
            return {
                ...(Latitude && { latitude: Latitude }),
                ...(Longitude && { longitude: Longitude }),
                ...(Code && { code: Code }),
                ...(Title && { name: Title }),
                ...(Description && { address: Description }),
                ...(Phone_number && { phone: Phone_number }),
                ...(Visit_Day && { visitDay: getDayNo(String(Visit_Day)) }),
                ...(Sales && { userId }),
            };
        });
    };

    return (
        <>
            <Title title={translate('resources.store.action.upload')} />
            <FileUpload
                headers={headers}
                fileInputLabel={translate('resources.store.action.upload')}
                api={ent.STORE.UPLOAD_API}
                resource={ent.STORE.NAME}
                verifyData={verifyData}
            />
        </>
    );
};
